import { Link } from '@ui-kit';
const User = '/images/icons/user-gray700.svg';
const IllustrationGray = '/images/icons/image-gray700.svg';
const InfoSmal = '/images/icons/help-circle-gray700.svg';
const CartSmal = '/images/icons/cart-gray700-sm.svg';
const FileIcon = '/images/icons/file-gray700.svg';

import {  
  CONTACTS_URL,
  ADMIN_PURCHASES_URL,
  ADMIN_USER_SETTINGS_URL,
  ADMIN_USER_PROJECTS_URL,
  ADMIN_PROJECTS_URL,
  ADMIN_USER_BILLS_URL,
} from "@app/routes";

export const MENU_LIST = [
  {component: (
      <Link to={ADMIN_USER_SETTINGS_URL} theme="text" alt="profile icon">
        View profile
      </Link>
    ),
    icon: User,
    isDivider: true
  },
  /*{component: (
    <Link to={ADMIN_FAVORITES_URL} theme="text" alt="favorites icon">
      My favorites
    </Link>
    ),
    icon: HeartIcon
  },*/
  {component: (
      <Link to={ADMIN_PURCHASES_URL} theme="text" alt="purchases icon">
        My purchases
      </Link>
    ),
    icon: CartSmal
  },
  {component: (
      <Link to={ADMIN_USER_PROJECTS_URL} theme="text" alt="projects icon">
        My projects
      </Link>
    ),
    icon: IllustrationGray,
  },
  {component: (
    <Link to={ADMIN_USER_BILLS_URL} theme="text" alt="bills icon">
      My tariff
    </Link>
    ),
    icon: FileIcon,
    isDivider: true
  },
  {component: (
      <Link to={CONTACTS_URL} theme="text" alt="support icon">
        Support
      </Link>
    ),
    icon: InfoSmal,
    isDivider: true
  }
];

export const MENU_LIST_ADMIN = [
  {component: (
      <Link to={ADMIN_USER_SETTINGS_URL} theme="text" alt="profile icon">
        View profile
      </Link>
    ),
    icon: User,
    isDivider: true
  },
  /*{component: (
    <Link to={ADMIN_FAVORITES_URL} theme="text" alt="favorites icon">
      My favorites
    </Link>
    ),
    icon: HeartIcon
  },*/
  {component: (
      <Link to={ADMIN_PURCHASES_URL} theme="text" alt="purchases icon">
        My purchases
      </Link>
    ),
    icon: CartSmal
  },
  {component: (
      <Link to={ADMIN_PROJECTS_URL} theme="text" alt="projects icon">
        My projects
      </Link>
    ),
    icon: IllustrationGray,
  },
  {component: (
    <Link to={ADMIN_USER_BILLS_URL} theme="text" alt="bills icon">
      My tariff
    </Link>
    ),
    icon: FileIcon,
    isDivider: true
  },
  {component: (
      <Link to={CONTACTS_URL} theme="text" alt="support icon">
        Support
      </Link>
    ),
    icon: InfoSmal,
    isDivider: true
  }
];

  
export const MENU_LANG_LIST = [
  {component: (
    <div id="en" className="link">
      English
    </div>
  )},
  {component: (
    <div id="ru" className="link">
      Russian
    </div>
  )},
];
